import React from 'react';

import { Chip, Text } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import { LocalizeCurrency } from '@change-corgi/core/react/i18n';

import { AmountInputContext } from '../AmountInputContext';

type Props = {
	onClick: () => void;
	isSelected: boolean;
	amount: number;
	currency: string;
};
export function AmountButtonChip({ onClick, isSelected, amount, currency }: Props): JSX.Element {
	// the ds `Chip` component uses `react-aria` under the hood which passes the onClick
	// to the underlying button. Something about this setup is
	// preventing the event from propagating up to the SelectionCard
	// so we must manually trigger the `onSelectYes` function here to ensure that the `YesSelection` is
	// selected when this chip is clicked

	const { onSelectYes } = React.useContext(AmountInputContext);

	function handleOnClick() {
		onClick();
		onSelectYes();
	}

	return (
		<Chip
			data-testid="sunrise-holdout-experiment-amount-selector-chip"
			as="button"
			className={cn('flex h-[52px] w-full items-center justify-center rounded-[4px] border-2', {
				'border-stroke-strong': !isSelected,
				'bg-[#F0F7FF]': isSelected,
			})}
			onClick={handleOnClick}
		>
			<Text size="large">
				<LocalizeCurrency value={amount} currency={currency} />
			</Text>
		</Chip>
	);
}
